import { Link, NavLink } from 'react-router-dom';
import Logo from '../../img/graphics/NAS Logo Color smaller.png';
import { links } from '../../data/Data';
import './Navbar.css';
import { HiOutlineBars3CenterLeft, HiXMark } from "react-icons/hi2";
import React, { useState, useRef } from 'react';

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(null);
  const closeTimer = useRef(null);

  const handleMouseEnter = (index) => {
    clearTimeout(closeTimer.current);
    setDropdownOpen(index);
  };

  const handleMouseLeave = () => {
    closeTimer.current = setTimeout(() => {
      setDropdownOpen(null);
    }, 200);
  };

  const toggleMenu = () => setMenuOpen(prev => !prev);

  const closeMenu = () => {
    setMenuOpen(false);
    setDropdownOpen(null);
  };

  return (
    <nav>
      {/* Overlay — closes menu when tapping outside */}
      <div
        className={`nav__overlay${menuOpen ? ' nav--open' : ''}`}
        onClick={closeMenu}
      />

      <div className="nav__container">
        <Link to="/" className="logo" onClick={closeMenu}>
          <img src={Logo} alt="NAS logo" />
        </Link>

        <ul className={`nav__links${menuOpen ? ' nav--open' : ''}`}>
          {links.map(({ name, path, subLinks }, index) => (
            <li
              key={index}
              className="nav__item"
              onMouseEnter={() => handleMouseEnter(index)}
              onMouseLeave={handleMouseLeave}
            >
              <NavLink
                to={path}
                className="nav__link"
                onClick={closeMenu}
              >
                {name}
              </NavLink>

              {/* Always render sublinks in DOM — CSS controls visibility */}
              {subLinks && (
                <ul className={`dropdown-menu${dropdownOpen === index ? ' dropdown--open' : ''}`}>
                  {subLinks.map((sub, subIndex) => (
                    <li key={subIndex}>
                      <NavLink
                        to={sub.path}
                        className="dropdown-link"
                        onClick={closeMenu}
                      >
                        {sub.name}
                      </NavLink>
                    </li>
                  ))}
                </ul>
              )}
            </li>
          ))}

          <li key="shop">
            <button className="nav-button">
              <Link
                to="https://www.etsy.com/shop/NatlAphasiaSynergy?ref=profile_header"
                target="_blank"
                rel="noopener noreferrer"
                onClick={closeMenu}
              >
                Shop
              </Link>
            </button>
          </li>
        </ul>

        <button
          className="nav__toggle-btn"
          onClick={toggleMenu}
          aria-label={menuOpen ? 'Close menu' : 'Open menu'}
          aria-expanded={menuOpen}
        >
          {menuOpen ? <HiXMark /> : <HiOutlineBars3CenterLeft />}
        </button>
      </div>
    </nav>
  );
};

export default Navbar;
